// 대시보드 표시용 순수 함수. 계약상 null 은 「셀 수 없음」 → 「–」.
export const DASH = "–";
const isNum = (v) => typeof v === "number" && Number.isFinite(v);

export const nf = (v) => (isNum(v) ? v.toLocaleString("ko-KR") : DASH);
// 비율 0~1 → %, 소수 한 자리(끝 0 제거)
export const pct = (r) => (isNum(r) ? `${Number((r * 100).toFixed(1))}%` : DASH);
export const sec = (v) => (isNum(v) ? `${Number(v.toFixed(2))}초` : DASH);
export const cnt = (v) => (isNum(v) ? `${v.toLocaleString("ko-KR")}건` : DASH);

// "2026-10-03" → "10월 3일" (Date 를 거치지 않아 시간대 영향이 없다)
export function dayLabel(date) {
    const [, m, d] = String(date || "").split("-");
    return m && d ? `${+m}월 ${+d}일` : String(date || "");
}

export const HOUR_LABELS = Array.from({ length: 24 }, (_, i) => `${i}:00`);

// 메타를 못 받았을 때의 상태 이름
export const FALLBACK_META = {
    statuses: [
        { code: "new", label: "접수" }, { code: "processing", label: "처리중" }, { code: "on_hold", label: "보류" },
        { code: "completed", label: "완료" }, { code: "canceled", label: "취소" },
    ],
};
